
import { Fostplus } from "@/models/base/fostplus";
import { FostplusService } from "@/services/fostplus-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			isNew: false,
			code: "",
			amount: 0.0
		};
	},
	props: {
		item: {
			type: Object as ()=>Fostplus,
			required: true
		},
		year: {
			type: Number,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			if (this.isNew) {
				return this.$ct("create-new-fostplus-item");
			}
			return this.$ct("edit-fostplus-item", {code: this.item.Code});
		},
		isValid():boolean {
			return this.code.trim() != "" && this.code.length <= 8;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (!this.isValid) return;
			await FostplusService.setFostplusAmount(this.code.trim(), this.amount, this.year);
			this.$emit("refresh");
			this.close();
		}
	},
	mounted() {
		this.isNew = this.item.Code == "";
		this.code = this.item.Code;
		this.amount = this.item.Amount;
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
